/* istanbul ignore file */
import React from 'react';
import { EditTimelineRecordButton } from 'domain/shared/timeline/button';
import { Collapsible, HtmlField } from 'framework/ui/field';
import { UPDATE_EMPLOYEE_NOTE } from 'domain/shared/employee';
import EmployeeNoteTag from 'domain/people/employee/Timeline/note/shared/layout/EmployeeNoteTag';
import { ReplaceUrlWithLink } from 'framework/utils';
import { TimelineType } from 'domain/shared/timeline/layout/BaseTimelineRecordLayout/timelineLayoutHelper';
import BasePersonTimelineRecordLayout from 'domain/shared/timeline/person/PersonTimelineRecord/BasePersonTimelineRecordLayout';
import EditNote from '@mui/icons-material/EditNote';
import Feedback from '@mui/icons-material/Feedback';
import useEmployeeTimelinePinAction from 'domain/people/employee/Timeline/shared/useEmployeeTimelinePinAction';
import type { BasePersonTimelineRecordLayoutProps } from 'domain/shared/timeline/person';
import { Box } from '@mui/material';
import { feedbackTimelineFooterSx } from 'domain/shared/timeline/layout/BaseTimelineRecordLayout/baseTimelineRecordSx';

interface EmployeeNoteTimelineRecordLayoutProps extends Partial<BasePersonTimelineRecordLayoutProps> {
  onEdit: () => void;
  isPinned?: boolean;
}

const EmployeeNoteTimelineRecordLayout = ({ onEdit, isPinned, ...props }: EmployeeNoteTimelineRecordLayoutProps) => {
  const pinActions = useEmployeeTimelinePinAction({ isPinned: !!isPinned, key: 'notePin' });

  const buttons = [<EditTimelineRecordButton permissionToCheck={UPDATE_EMPLOYEE_NOTE} key="edit" onEdit={onEdit} />];

  // Define employee timeline icons
  const EMPLOYEE_TIMELINE_ICONS: Record<string, React.ComponentType<any>> = {
    [TimelineType.NOTE]: EditNote,
    [TimelineType.FEEDBACK]: Feedback,
    default: EditNote,
  };

  return (
    <BasePersonTimelineRecordLayout
      actions={pinActions}
      timelineType={TimelineType.NOTE}
      buttons={buttons}
      timelineIcons={EMPLOYEE_TIMELINE_ICONS}
      actionName=""
      permissionToCheck={null}
      messageContext=""
      fields={
        <Collapsible>
          <ReplaceUrlWithLink>
            <HtmlField source="noteText" label="" />
          </ReplaceUrlWithLink>
        </Collapsible>
      }
      timelineFooter={rest => (
        <Box mt="0.75rem" sx={feedbackTimelineFooterSx}>
          <EmployeeNoteTag {...rest} />
        </Box>
      )}
      {...props}
      isCandidateService={false}
    />
  );
};

export default EmployeeNoteTimelineRecordLayout;
